import React, { useRef, useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import { launchesActions } from "../../../store/launches/launchesActions";

const AddLaunchesPopup = ({
  closePopup,
  openPopup,
  startLoading,
  endLoading,
  loadData,
  editData,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const addLaunchForm = useRef("form");
  const [planName, setPlanName] = useState("");
  const [planDate, setPlanDate] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    startLoading();
    if (isEdit) {
      dispatch(
        launchesActions.onUpdateLaunches(planName, planDate, editData.id)
      ).then((data) => {
        closePopup();
        loadData();
      });
    } else {
      dispatch(launchesActions.onAddLaunches(planName)).then((data) => {
        closePopup();
        loadData();
      });
    }
  };
  useEffect(() => {
    if (isEdit) {
      setPlanName(editData.launch_plan);
      setPlanDate(editData.launch_date);
    }
  }, []);
  return (
    <div>
      <Dialog
        open={openPopup}
        onClose={closePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ValidatorForm ref={addLaunchForm} onSubmit={handleSubmit}>
          <DialogTitle id="alert-dialog-title">
            {isEdit ? "Update launch" : "Add new launch"}
          </DialogTitle>
          <DialogContent className="addLaunchPopupWrapper">
            <DialogContentText id="alert-dialog-description">
              <TextValidator
                id="planName"
                label="Launch Plan"
                variant="outlined"
                name="planName"
                fullWidth
                validators={["required"]}
                errorMessages={["Field is required"]}
                value={planName}
                onChange={(v) => setPlanName(v.target.value)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Button onClick={closePopup} color="primary" variant="outlined">
              Cancel
            </Button>
            <Button
              // onClick={closePopup}
              color="primary"
              variant="contained"
              autoFocus
              type="submit"
            >
              {isEdit ? "Update launch" : "Add new launch"}
            </Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    </div>
  );
};

export default AddLaunchesPopup;
